import { useCallback, useEffect, useState } from 'react';
import { getSummaryInputs, setSummaryInput } from '../../data/stocks';

/**
 * The hand-entered Starting Values, and a setter that saves one.
 *
 * A failed read leaves the inputs empty rather than failing the page: every
 * figure that needs one already renders as "needs input".
 */
export default function useSummaryInputs() {
    const [inputs, setInputs] = useState({});

    useEffect(() => {
        let cancelled = false;
        getSummaryInputs()
            .then((result) => { if (!cancelled) setInputs(result?.inputs ?? {}); })
            .catch(() => {});
        return () => { cancelled = true; };
    }, []);

    const setInput = useCallback(async (key, value) => {
        try {
            const result = await setSummaryInput(key, value);
            setInputs(result?.inputs ?? {});
            return true;
        } catch {
            return false;
        }
    }, []);

    return { inputs, setInput };
}
